import type { ReactNode } from 'react';
import css from './map-popup.module.scss';

// Styled content shell for a Leaflet `<Popup>` — thumbnail + title + any
// extra rows the host passes as children. Domain-agnostic; the host
// supplies the (already-resolved) thumbnail URL and title.
export const MapPopup = ({
  thumbnail,
  title,
  children,
}: {
  thumbnail?: string | null;
  title: string;
  children?: ReactNode;
}) => (
  <div className={css.root}>
    {thumbnail ? (
      <img alt="" className={css.image} loading="lazy" src={thumbnail} />
    ) : (
      <div className={css.imagePlaceholder} />
    )}
    <div className={css.body}>
      {title ? <div className={css.title}>{title}</div> : null}
      {children}
    </div>
  </div>
);
